import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ListLinks } from '../../../../@core/constants/list-links';
import { Bank } from '../../../../generated/generated-types';
import { GenericBaseModelDropDown } from '../../../../shared/components/genericBaseModelDropDown';
import { BankService } from '../../services/bank.service';
import { BankEditWidgetComponent } from '../bank-edit-widget/bank-edit-widget.component';

@Component({
  selector: 'app-bank-list-dropdown',
  templateUrl: './bank-list-dropdown.component.html',
  providers: [BankService],
  standalone: true,
  imports: [
    CommonModule,
  ]
})
export class BankListDropdownComponent extends GenericBaseModelDropDown<Bank> {

  constructor(private service: BankService) {
    super(service, "Bank");
    this.createNewPopupComponent = BankEditWidgetComponent;
    this.listUrl.set(ListLinks.BANK);

  }

}
